/*
 * Talika — moteur de diagnostic partagé (extrait de skin-diagnostic.js, P1 Consultation)
 * Règles produits (docx 2021 actualisé gamme 2026), tracking Klaviyo, panier.
 * Expose window.TalikaEngine. Aucune dépendance UI.
 */
(function () {
  'use strict';

  const config = window.TalikaConfig || { products: {}, currency: 'EUR' };
  const products = config.products || {};

  const productMapping = {
    cleanser: 'mousse-nettoyante-hydratante-skintellige',
    eauMicellaire: 'eau-micellaire-hydratante',
    serumHydra: 'serum-hydra',
    serumAntiAge: 'serum-anti-age',
    serumPurifiant: 'serum-purifiant-skintelligence',
    glowtion: 'glowtion',
    gommage: 'gommage-doux-hydratant',
    dayCremeLight: 'creme-legere-hydra',
    dayCremeRich: 'creme-riche-hydra',
    dayCremeAntiAgeDry: 'creme-de-jour-regenerante-anti-age',
    nightCremeAntiAgeDry: 'creme-de-nuit-regenerante-anti-age',
    dayCremeAntiAgeOily: 'gel-creme-anti-age-jour',
    nightCremeAntiAgeOily: 'gel-creme-anti-age-nuit',
    gelCremePurifiant: 'gel-creme-purifiant',
    maskHydrating: 'bio-enzymes-mask-hydratant',
    maskAntiAge: 'bio-enzymes-mask-anti-age',
    maskPurifying: 'bio-enzymes-mask-purifiant',
    maskBrightening: 'bio-enzymes-mask-eclaircissant',
    maskSoothing: 'bio-enzymes-mask-cica-repair-apaisant',
    freeSkin: 'free-skin',
    bubbleMask: 'bubble-mask-bio-detox',
    timeControl: 'time-control-7-plus',
    lipocils: 'lipocils',
    lipocilsExpert: 'lipocils-expert-le-soin-culte',
    lipocilsPlatinium: 'lipocils-platinium',
    lipocilsDemaquillant: 'lipocils-demaquillant',
    lipocilsCrayon: 'lipocils-crayon',
    mascaraClassic: 'lipocils-mascara-1',
    mascaraXXLVolume: 'lipocils-mascara-xxl-volume',
    mascaraXXLExtension: 'lipocils-mascara-xxl-extension',
    mascaraExtensionWR: 'lipocils-mascara-xxl-extension-black-water-resistant',
  };

  // Descriptions dérivées des fiches Shopify — ne jamais inventer de claim
  const productDatabase = {
    cleanser: { name: 'Mousse Nettoyante Hydratante Skintelligence', description: 'Mousse nettoyante hydratante pour tous types de peau' },
    eauMicellaire: { name: 'Eau Micellaire Hydratante Skintelligence', description: 'Eau micellaire démaquillante et nettoyante' },
    serumHydra: { name: 'Serum Hydra Skintelligence', description: 'Sérum ultra-hydratant à l\'acide hyaluronique' },
    serumAntiAge: { name: 'Serum Anti-Age Skintelligence', description: 'Sérum anti-âge concentré aux peptides' },
    serumPurifiant: { name: 'Serum Purifiant Skintelligence', description: 'Sérum purifiant pour peaux à imperfections' },
    glowtion: { name: 'Glowtion', description: 'Lotion éclat révélatrice de luminosité' },
    gommage: { name: 'Gommage Doux Hydratant', description: 'Gommage doux exfoliant et hydratant' },
    dayCremeLight: { name: 'Crème Légère Hydra Skintelligence', description: 'Crème hydratante légère jour' },
    dayCremeRich: { name: 'Crème Riche Hydra Skintelligence', description: 'Crème hydratante riche jour et nuit' },
    dayCremeAntiAgeDry: { name: 'Crème de Jour Régénérante Anti-Age', description: 'Crème de jour anti-âge pour peaux sèches' },
    nightCremeAntiAgeDry: { name: 'Crème de Nuit Régénérante Anti-Age', description: 'Crème de nuit anti-âge pour peaux sèches' },
    dayCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Jour', description: 'Gel-crème de jour anti-âge pour peaux grasses et mixtes' },
    nightCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Nuit', description: 'Gel-crème de nuit anti-âge pour peaux grasses et mixtes' },
    gelCremePurifiant: { name: 'Gel-Crème Purifiant', description: 'Gel-crème purifiant pour peaux mixtes à grasses' },
    maskHydrating: { name: 'Bio Enzymes Mask Hydratant', description: 'Masque biocellulose ultra-hydratant' },
    maskAntiAge: { name: 'Bio Enzymes Mask Anti-Age', description: 'Masque biocellulose anti-âge au collagène' },
    maskPurifying: { name: 'Bio Enzymes Mask Purifiant', description: 'Masque biocellulose purifiant aux acides de fruits' },
    maskBrightening: { name: 'Bio Enzymes Mask Éclaircissant', description: 'Masque biocellulose éclat anti-taches à la vitamine C' },
    maskSoothing: { name: 'Bio Enzymes Mask Cica Repair Apaisant', description: 'Masque apaisant réparateur à la Centella Asiatica' },
    freeSkin: { name: 'Free Skin Light Therapy Device', description: 'Appareil de luminothérapie anti-imperfections' },
    bubbleMask: { name: 'Bubble Mask Bio-Detox', description: 'Masque moussant détoxifiant au charbon' },
    timeControl: { name: 'Time Control 7+ Multi-Correction', description: 'Soin anti-âge ciblé multi-correction intensif' },
    lipocils: { name: 'Lipocils', description: 'Soin stimulant la pousse des cils au Complexe Végétal Mythique' },
    lipocilsExpert: { name: 'Lipocils Expert', description: 'Sérum culte : pousse, courbure et pigmentation naturelle des cils' },
    lipocilsPlatinium: { name: 'Lipocils Platinium', description: 'Duo sérums jour/nuit : des cils plus longs, plus nombreux, plus foncés' },
    lipocilsDemaquillant: { name: 'Lipocils Démaquillant', description: 'Baume démaquillant qui stimule la pousse des cils' },
    lipocilsCrayon: { name: 'Lipocils Crayon', description: 'Crayon yeux à la texture fondante qui fortifie les cils' },
    mascaraClassic: { name: 'Lipocils Mascara', description: 'Mascara soin : longueur, courbure et pousse des cils' },
    mascaraXXLVolume: { name: 'Lipocils Mascara XXL Volume', description: 'Mascara volume qui stimule la pousse des cils' },
    mascaraXXLExtension: { name: 'Lipocils Mascara XXL Extension', description: 'Mascara effet extension qui maquille et fait pousser les cils' },
    mascaraExtensionWR: { name: 'Lipocils Mascara Extension Water Resistant', description: 'Mascara extension résistant à l\'eau, au complexe pousse des cils' },
  };

  const PRODUCT_TARGETS = {
    serumAntiAge: ['wrinkles'], maskAntiAge: ['wrinkles'],
    dayCremeAntiAgeDry: ['wrinkles'], nightCremeAntiAgeDry: ['wrinkles'],
    dayCremeAntiAgeOily: ['wrinkles'], nightCremeAntiAgeOily: ['wrinkles'],
    serumPurifiant: ['imperfections'], maskPurifying: ['imperfections'],
    bubbleMask: ['imperfections'], freeSkin: ['imperfections'], gelCremePurifiant: ['imperfections'],
    serumHydra: ['dehydration'], maskHydrating: ['dehydration'],
    maskSoothing: ['sensitivity'],
    maskBrightening: ['spots'], timeControl: ['spots'],
    lipocilsPlatinium: ['fuller'], lipocilsExpert: ['pigmented', 'curled'],
    lipocils: ['longer', 'resistant'],
  };
  const TARGET_LABELS = {
    wrinkles: 'rides', imperfections: 'imperfections', dehydration: 'hydratation',
    sensitivity: 'apaisement', spots: 'anti-taches',
    fuller: 'cils plus fournis', pigmented: 'pigmentation', curled: 'courbure',
    longer: 'longueur', resistant: 'résistance',
  };

  // Reflète le code Shopify DIAG20 (−20 € dès 100 €)
  const ROUTINE_OFFER = { code: 'DIAG20', amountCents: 2000, thresholdCents: 10000 };

  // --- Questions (identiques à la V2, source de vérité pour la consultation) ---
  const QUESTIONS = {
    universe: {
      id: 'universe', type: 'radio',
      options: [
        { value: 'skin', label: 'Ma peau — une routine visage personnalisée' },
        { value: 'lashes', label: 'Mon regard — des cils plus beaux' },
      ],
    },
    skin: [
      { id: 'age', type: 'radio', options: [
        { value: 'under25', label: 'Moins de 25 ans' },
        { value: '25-35', label: '25-35 ans' },
        { value: '35-45', label: '35-45 ans' },
        { value: 'over45', label: 'Plus de 45 ans' },
      ]},
      { id: 'skinType', type: 'radio', options: [
        { value: 'dry', label: 'Sèche (tiraillements, inconfort)', icon: '🍂' },
        { value: 'oily', label: 'Grasse (brillances, pores dilatés)', icon: '🥑' },
        { value: 'combination', label: 'Mixte (zone T grasse, joues normales)', icon: '🌗' },
        { value: 'normal', label: 'Normale (équilibrée, confortable)', icon: '⚖️' },
      ]},
      { id: 'concerns', type: 'checkbox', options: [
        { value: 'wrinkles', label: 'Rides et signes de l\'âge', icon: '⏳' },
        { value: 'imperfections', label: 'Imperfections', icon: '🫧' },
        { value: 'dehydration', label: 'Déshydratation, manque d\'éclat', icon: '💧' },
        { value: 'sensitivity', label: 'Sensibilité, rougeurs', icon: '🌷' },
        { value: 'spots', label: 'Taches pigmentaires', icon: '☀️' },
      ]},
    ],
    lashes: [
      { id: 'lashWishes', type: 'checkbox', options: [
        { value: 'longer', label: 'Des cils plus longs', icon: '📏' },
        { value: 'fuller', label: 'Une frange plus fournie', icon: '🪶' },
        { value: 'pigmented', label: 'Plus pigmentés', icon: '🖤' },
        { value: 'curled', label: 'Mieux recourbés', icon: '⤴️' },
        { value: 'resistant', label: 'Plus résistants', icon: '💪' },
      ]},
      { id: 'lashMascara', type: 'radio', options: [
        { value: 'yes', label: 'Oui, tous les jours ou presque' },
        { value: 'no', label: 'Non, rarement' },
      ]},
      { id: 'mascaraType', type: 'radio', condition: a => a.lashMascara === 'yes', options: [
        { value: 'volume', label: 'Du volume XXL', productKey: 'mascaraXXLVolume' },
        { value: 'length', label: 'De la longueur (effet extension)', productKey: 'mascaraXXLExtension' },
        { value: 'waterproof', label: 'De la tenue (résistant à l\'eau)', productKey: 'mascaraExtensionWR' },
        { value: 'natural', label: 'Un résultat naturel', productKey: 'mascaraClassic' },
      ]},
      { id: 'lashEyeliner', type: 'radio', options: [
        { value: 'yes', label: 'Oui, régulièrement' },
        { value: 'no', label: 'Non' },
      ]},
    ],
  };

  // --- Règles ---
  function hasAgingSigns(concerns, age) {
    return concerns.includes('wrinkles') || age === 'over45' || age === '35-45';
  }

  function skinRoutine(answers) {
    const { skinType, age } = answers;
    const concerns = answers.concerns || [];
    const hasImp = concerns.includes('imperfections');
    const routine = { morning: [], evening: [], weekly: [], targeted: [] };
    if (hasAgingSigns(concerns, age)) {
      if (['normal', 'dry'].includes(skinType)) {
        routine.morning = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'dayCremeAntiAgeDry'];
        routine.evening = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'nightCremeAntiAgeDry'];
        routine.weekly = ['maskAntiAge'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion', 'serumAntiAge'].concat(hasImp ? ['serumPurifiant', 'dayCremeAntiAgeOily'] : ['dayCremeAntiAgeOily']);
        routine.evening = ['cleanser', 'glowtion', 'serumAntiAge'].concat(hasImp ? ['serumPurifiant', 'nightCremeAntiAgeOily'] : ['nightCremeAntiAgeOily']);
        routine.weekly = ['maskAntiAge'].concat(hasImp ? ['maskPurifying'] : []);
        if (hasImp) routine.targeted = ['freeSkin'];
      }
    } else {
      if (skinType === 'normal') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeLight'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeLight'];
        routine.weekly = ['maskHydrating'];
      } else if (skinType === 'dry') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeRich'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeRich'];
        routine.weekly = ['maskHydrating'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion'].concat(hasImp ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant']);
        routine.evening = ['cleanser', 'glowtion'].concat(hasImp ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant']);
        routine.weekly = ['maskPurifying'].concat(hasImp ? ['bubbleMask'] : []);
        if (hasImp) routine.targeted = ['freeSkin'];
      }
    }
    if (concerns.includes('spots')) {
      if (!routine.weekly.includes('maskBrightening')) routine.weekly.push('maskBrightening');
      if (!routine.targeted.includes('timeControl')) routine.targeted.push('timeControl');
    }
    if (concerns.includes('sensitivity')) {
      if (!routine.weekly.includes('maskSoothing')) routine.weekly.push('maskSoothing');
      routine.weekly = routine.weekly.filter(p => p !== 'bubbleMask');
    }
    if (concerns.includes('dehydration') && !routine.weekly.includes('maskHydrating')) {
      routine.weekly.push('maskHydrating');
    }
    return routine;
  }

  // Docx 2021 : fournis → Platinium ; pigmentés/recourbés → Expert ; sinon Lipocils.
  // Soin matin+soir, ou soir seulement si maquillage quotidien.
  function lashRoutine(answers) {
    const wishes = answers.lashWishes || [];
    const usesMascara = answers.lashMascara === 'yes';
    const usesEyeliner = answers.lashEyeliner === 'yes';
    const wearsMakeup = usesMascara || usesEyeliner;
    const mascaraByType = { volume: 'mascaraXXLVolume', length: 'mascaraXXLExtension', waterproof: 'mascaraExtensionWR', natural: 'mascaraClassic' };
    const care = wishes.includes('fuller') ? 'lipocilsPlatinium'
      : (wishes.includes('pigmented') || wishes.includes('curled')) ? 'lipocilsExpert' : 'lipocils';
    const routine = { morning: [], evening: [], weekly: [], targeted: [] };
    if (!wearsMakeup) routine.morning.push(care);
    if (usesMascara) routine.morning.push(mascaraByType[answers.mascaraType] || 'mascaraClassic');
    if (usesEyeliner) routine.morning.push('lipocilsCrayon');
    routine.evening.push(care, wearsMakeup ? 'lipocilsDemaquillant' : 'eauMicellaire');
    return routine;
  }

  function computeRoutine(answers, savedRoutine) {
    let routine = answers.universe === 'lashes' ? lashRoutine(answers) : skinRoutine(answers);
    if (savedRoutine) {
      routine = {
        morning: [...new Set([...savedRoutine.morning, ...routine.morning])],
        evening: [...new Set([...savedRoutine.evening, ...routine.evening])],
        weekly: [...new Set([...savedRoutine.weekly, ...routine.weekly])],
        targeted: [...new Set([...savedRoutine.targeted, ...routine.targeted])],
      };
    }
    const available = key => !!products[productMapping[key]];
    return {
      morning: routine.morning.filter(available),
      evening: routine.evening.filter(available),
      weekly: routine.weekly.filter(available),
      targeted: routine.targeted.filter(available),
    };
  }

  function uniqueKeys(routine) {
    return [...new Set([...routine.morning, ...routine.evening, ...routine.weekly, ...routine.targeted])];
  }

  // --- Produits / prix ---
  function getProduct(key) {
    const handle = productMapping[key];
    const p = products[handle];
    if (!p) return null;
    const info = productDatabase[key] || {};
    return {
      key, handle,
      name: info.name || p.title,
      description: info.description || '',
      priceCents: typeof p.price === 'number' ? p.price : 0,
      priceFormatted: p.price_formatted || '',
      image: p.featured_image ? (String(p.featured_image).indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '',
      available: !!(p.variants && p.variants[0] && p.variants[0].available),
      variantId: p.variants && p.variants[0] ? p.variants[0].id : null,
    };
  }

  function routineValueCents(keys) {
    return keys.reduce((t, k) => { const p = getProduct(k); return t + (p ? p.priceCents : 0); }, 0);
  }
  function formatEuros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  function routineUsage(routine, key) {
    const inM = routine.morning.includes(key), inE = routine.evening.includes(key);
    const parts = [];
    if (inM && inE) parts.push('Matin & soir');
    else if (inM) parts.push('Le matin');
    else if (inE) parts.push('Le soir');
    if (routine.weekly.includes(key)) parts.push('1 à 2 fois par semaine');
    if (routine.targeted.includes(key)) parts.push('Soin ciblé');
    return parts.join(' · ');
  }

  function concernTag(answers, key) {
    const selected = [].concat(answers.concerns || [], answers.lashWishes || []);
    const match = (PRODUCT_TARGETS[key] || []).find(t => selected.includes(t));
    return match ? TARGET_LABELS[match] : null;
  }

  // --- Panier ---
  async function addToCart(key) {
    const p = getProduct(key);
    if (!p || !p.variantId || !p.available) throw new Error('Produit indisponible');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: p.variantId, quantity: 1, properties: { '_diagnostic': 'talika-consultation', '_source': 'consultation-beaute' } }),
    });
    if (!response.ok) throw new Error('Erreur HTTP ' + response.status);
    return true;
  }

  async function addRoutineToCart(keys) {
    let ok = 0, ko = 0;
    for (const key of keys) {
      try { await addToCart(key); ok++; } catch (e) { ko++; }
      await new Promise(r => setTimeout(r, 150));
    }
    return { ok, ko };
  }

  // --- Klaviyo ---
  function track(eventName, properties) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, Object.assign({ source: 'talika-consultation', page_url: window.location.href }, properties)]);
    } catch (e) { /* le suivi ne casse jamais le parcours */ }
  }
  function identify(properties) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', properties]);
    } catch (e) { /* idem */ }
  }

  function buildIdentifyProps(answers, routine, doneUniverses) {
    const names = keys => keys.map(k => (productDatabase[k] || {}).name).filter(Boolean);
    const props = {
      diagnostic_universe: [].concat(doneUniverses || [], answers.universe || 'skin').join('+'),
      diagnostic_date: new Date().toISOString(),
      diagnostic_routine_value: routineValueCents(uniqueKeys(routine)) / 100,
      diagnostic_morning_routine: names(routine.morning),
      diagnostic_evening_routine: names(routine.evening),
      diagnostic_weekly_routine: names(routine.weekly),
      diagnostic_targeted_routine: names(routine.targeted),
      diagnostic_input_method: 'questions',
    };
    if (answers.skinType) props.diagnostic_skin_type = answers.skinType;
    if (answers.age) props.diagnostic_age_range = answers.age;
    if ((answers.concerns || []).length) props.diagnostic_concerns = answers.concerns;
    if ((answers.lashWishes || []).length) props.diagnostic_lash_wishes = answers.lashWishes;
    return props;
  }

  window.TalikaEngine = {
    QUESTIONS, ROUTINE_OFFER, PRODUCT_TARGETS, TARGET_LABELS,
    productMapping, productDatabase,
    computeRoutine, uniqueKeys, getProduct,
    routineValueCents, formatEuros, routineUsage, concernTag,
    addToCart, addRoutineToCart, track, identify, buildIdentifyProps,
  };
})();
